
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Update, GetById, GetEmployeeList } from "adminApi/AwardApi/AwardApi";
import { validateForm } from "utils/validation";
import { AwardRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditAwardForm from "./components/EditAwardForm";
import fields from "../json/Award.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import useFetchAllData from "Hooks/useFetchAllData";

const EditAward = () => {
    const navigate = useNavigate();
    const { formdata } = fields;
    const { id } = useParams();

    // Initialize form values from JSON fields
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setErrors, setValues } = useFormChange(
        initialValues,
        AwardRules
    );

    // Fetch existing data by ID and prepopulate form
    const { loading: loadingFetch } = useFetchFormDataById(
        id,
        formdata,
        GetById,
        setValues
    );

    const { data: employeeOptions, loading: loadingEmployees } = useFetchAllData(GetEmployeeList);

    // Form submit
    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        async (formValues) => {
            return await Update({ id, data: formValues });
        },
        (vals) => {
            const err = validateForm(vals, AwardRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Award updated successfully"
    );

    return (
        <>
            {(loadingSubmit || loadingFetch || loadingEmployees) && <Spinner isSpinner={true} />}
            <EditAwardForm
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                employeeOptions={employeeOptions}
            />
        </>
    );
};

export default EditAward;
